import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ReactSortable } from "react-sortablejs";
import { Link } from "react-router-dom";
import { onCategoriesChangeItemPosition } from "../../store/Categories/actions";
import { onModifiersChangeItemPosition } from "../../store/Modifiers/actions";

export const SortableItems = ({ items, isModifier }) => {
    const dispatch = useDispatch();
    const [state, setState] = useState([]);

    useEffect(() => setState(items), [items]);

    const onItemChange = () => {
        isModifier
            ? dispatch(onModifiersChangeItemPosition(state))
            : dispatch(onCategoriesChangeItemPosition(state))
        };

    if (!items) return null;

    return (
        <ReactSortable
            list={state}
            setList={setState}
            onEnd={onItemChange}
            swap= {true}
            animation= {150}>
            {state.map((item) => (
                <div
                    key={item.id}
                    className="bg-gray-50 flex items-center justify-between sm:rounded-lg my-1 mx-auto px-2 w-11/12"
                >
                    <div className="flex items-center p-2">
                        <div>
                            {isModifier
                                ?   <Link to={`#`}/>
                                :   <Link to={`/chain/menu/${item.category_id}/dishes/${item.id}/edit`}>
                                        <img
                                            className="rounded-full"
                                            src={item.photo_thumb ?? item.photo}
                                            width={42}
                                            height={42}
                                            alt=""
                                        />
                                    </Link> }
                        </div>
                        <span className="text-xs font-normal text-purple-500 px-11">
                            {isModifier
                                ?   <Link to={`#`}>
                                        {item.name}
                                    </Link>
                                :   <Link to={`/chain/menu/${item.category_id}/dishes/${item.id}/edit`}>
                                        {item.name}
                                    </Link>}
                        </span>
                    </div>
                </div>
            ))}
        </ReactSortable>
    );
};
